import { Dict } from '@chakra-ui/utils';

export const globalStyles = {
	colors: {
		gray: {
			700: '#1f2733'
		}
	},
	styles: {
		global: (props: Dict) => ({
			body: {
				bg: 'var(--background)',
				fontFamily: "'Urbanist', sans-serif"
			},
			html: {
				bg: 'var(--background)',
				fontFamily: "'Urbanist', sans-serif"
			},
			'body:has([data-app-auth-surface])': {
				bg: 'var(--muted) !important',
			},
			'[data-portal]': {
				zIndex: '999999 !important'
			},
			'[data-chakra-portal]': {
				zIndex: '999999 !important'
			},
			'div[data-portal]': {
				zIndex: '999999 !important'
			},
			// Toast notification styles
			// Position toast container at top-right
			'#chakra-toast-manager-top-right, [id*="toast-manager-top-right"], [id*="chakra-toast-manager"]': {
				top: '1rem !important',
				right: '1rem !important',
				bottom: 'auto !important',
			},
			// Success toasts and alerts - Glacial Green
			'[data-status="success"], .chakra-alert[data-status="success"], div.chakra-alert[data-status="success"], [role="alert"][data-status="success"]': {
				background: 'linear-gradient(135deg, #06E363, #AAFAB1) !important',
				backgroundImage: 'linear-gradient(135deg, #06E363, #AAFAB1) !important',
				backgroundColor: 'transparent !important',
				color: 'white !important',
			},
			'[data-status="success"] *, .chakra-alert[data-status="success"] *, [role="alert"][data-status="success"] *': {
				color: 'white !important',
			},
			'[data-status="success"] [data-icon], .chakra-alert[data-status="success"] [data-icon], [role="alert"][data-status="success"] [data-icon]': {
				color: 'white !important',
			},
			'[data-status="success"] button, .chakra-alert[data-status="success"] button, [role="alert"][data-status="success"] button': {
				color: 'white !important',
			},
			'[data-status="success"] [data-title], .chakra-alert[data-status="success"] [data-title], [role="alert"][data-status="success"] [data-title]': {
				color: 'white !important',
			},
			'[data-status="success"] [data-description], .chakra-alert[data-status="success"] [data-description], [role="alert"][data-status="success"] [data-description]': {
				color: 'rgba(255, 255, 255, 0.9) !important',
			},
			// Error toasts - Glacial Red
			'[data-status="error"], .chakra-alert[data-status="error"], div.chakra-alert[data-status="error"], [role="alert"][data-status="error"]': {
				background: 'linear-gradient(135deg, #E00101, #FE4244) !important',
				backgroundImage: 'linear-gradient(135deg, #E00101, #FE4244) !important',
				backgroundColor: 'transparent !important',
				color: 'white !important',
			},
			'[data-status="error"] *, .chakra-alert[data-status="error"] *, [role="alert"][data-status="error"] *': {
				color: 'white !important',
			},
			'[data-status="error"] [data-icon], .chakra-alert[data-status="error"] [data-icon], [role="alert"][data-status="error"] [data-icon]': {
				color: 'white !important',
			},
			'[data-status="error"] button, .chakra-alert[data-status="error"] button, [role="alert"][data-status="error"] button': {
				color: 'white !important',
			},
			'[data-status="error"] [data-title], .chakra-alert[data-status="error"] [data-title], [role="alert"][data-status="error"] [data-title]': {
				color: 'white !important',
			},
			'[data-status="error"] [data-description], .chakra-alert[data-status="error"] [data-description], [role="alert"][data-status="error"] [data-description]': {
				color: 'rgba(255, 255, 255, 0.9) !important',
			},
			// Warning toasts - Glacial Orange
			'[data-status="warning"], .chakra-alert[data-status="warning"], div.chakra-alert[data-status="warning"], [role="alert"][data-status="warning"]': {
				background: 'linear-gradient(135deg, #F45B0B, #F49113) !important',
				backgroundImage: 'linear-gradient(135deg, #F45B0B, #F49113) !important',
				backgroundColor: 'transparent !important',
				color: 'white !important',
			},
			'[data-status="warning"] *, .chakra-alert[data-status="warning"] *, [role="alert"][data-status="warning"] *': {
				color: 'white !important',
			},
			'[data-status="warning"] [data-icon], .chakra-alert[data-status="warning"] [data-icon], [role="alert"][data-status="warning"] [data-icon]': {
				color: 'white !important',
			},
			'[data-status="warning"] button, .chakra-alert[data-status="warning"] button, [role="alert"][data-status="warning"] button': {
				color: 'white !important',
			},
			'[data-status="warning"] [data-title], .chakra-alert[data-status="warning"] [data-title], [role="alert"][data-status="warning"] [data-title]': {
				color: 'white !important',
			},
			'[data-status="warning"] [data-description], .chakra-alert[data-status="warning"] [data-description], [role="alert"][data-status="warning"] [data-description]': {
				color: 'rgba(255, 255, 255, 0.9) !important',
			},
			// Information toasts - Primary Gradient
			'[data-status="info"], .chakra-alert[data-status="info"], div.chakra-alert[data-status="info"], [role="alert"][data-status="info"]': {
				background: 'linear-gradient(135deg, #38BBD1, #3EEAEC) !important',
				backgroundImage: 'linear-gradient(135deg, #38BBD1, #3EEAEC) !important',
				backgroundColor: 'transparent !important',
				color: 'white !important',
			},
			'[data-status="info"] *, .chakra-alert[data-status="info"] *, [role="alert"][data-status="info"] *': {
				color: 'white !important',
			},
			'[data-status="info"] [data-icon], .chakra-alert[data-status="info"] [data-icon], [role="alert"][data-status="info"] [data-icon]': {
				color: 'white !important',
			},
			'[data-status="info"] button, .chakra-alert[data-status="info"] button, [role="alert"][data-status="info"] button': {
				color: 'white !important',
			},
			'[data-status="info"] [data-title], .chakra-alert[data-status="info"] [data-title], [role="alert"][data-status="info"] [data-title]': {
				color: 'white !important',
			},
			'[data-status="info"] [data-description], .chakra-alert[data-status="info"] [data-description], [role="alert"][data-status="info"] [data-description]': {
				color: 'rgba(255, 255, 255, 0.9) !important',
			},
			// Alert component styles - Apply to ALL alerts (both toast and regular)
			// These styles will override any default Chakra UI Alert styles
			// Success Alerts - Glacial Green
			'.chakra-alert[data-status="success"], [role="alert"][data-status="success"], div.chakra-alert[data-status="success"], div[role="alert"][data-status="success"]': {
				background: 'linear-gradient(135deg, #06E363, #AAFAB1) !important',
				backgroundImage: 'linear-gradient(135deg, #06E363, #AAFAB1) !important',
				backgroundColor: 'transparent !important',
				color: 'white !important',
			},
			'.chakra-alert[data-status="success"] *, [role="alert"][data-status="success"] *, div.chakra-alert[data-status="success"] *, div[role="alert"][data-status="success"] *': {
				color: 'white !important',
			},
			// Error Alerts - Glacial Red
			'.chakra-alert[data-status="error"], [role="alert"][data-status="error"], div.chakra-alert[data-status="error"], div[role="alert"][data-status="error"]': {
				background: 'linear-gradient(135deg, #E00101, #FE4244) !important',
				backgroundImage: 'linear-gradient(135deg, #E00101, #FE4244) !important',
				backgroundColor: 'transparent !important',
				color: 'white !important',
			},
			'.chakra-alert[data-status="error"] *, [role="alert"][data-status="error"] *, div.chakra-alert[data-status="error"] *, div[role="alert"][data-status="error"] *': {
				color: 'white !important',
			},
			// Warning Alerts - Glacial Orange
			'.chakra-alert[data-status="warning"], [role="alert"][data-status="warning"], div.chakra-alert[data-status="warning"], div[role="alert"][data-status="warning"]': {
				background: 'linear-gradient(135deg, #F45B0B, #F49113) !important',
				backgroundImage: 'linear-gradient(135deg, #F45B0B, #F49113) !important',
				backgroundColor: 'transparent !important',
				color: 'white !important',
			},
			'.chakra-alert[data-status="warning"] *, [role="alert"][data-status="warning"] *, div.chakra-alert[data-status="warning"] *, div[role="alert"][data-status="warning"] *': {
				color: 'white !important',
			},
			// Info Alerts - Primary Gradient
			'.chakra-alert[data-status="info"], [role="alert"][data-status="info"], div.chakra-alert[data-status="info"], div[role="alert"][data-status="info"]': {
				background: 'linear-gradient(135deg, #38BBD1, #3EEAEC) !important',
				backgroundImage: 'linear-gradient(135deg, #38BBD1, #3EEAEC) !important',
				backgroundColor: 'transparent !important',
				color: 'white !important',
			},
			'.chakra-alert[data-status="info"] *, [role="alert"][data-status="info"] *, div.chakra-alert[data-status="info"] *, div[role="alert"][data-status="info"] *': {
				color: 'white !important',
			},
			// Chakra Switch only — never target shadcn [data-slot="switch"]
			'button[role="switch"]:not([data-slot="switch"]):focus, button[role="switch"]:not([data-slot="switch"]):focus-visible, button[role="switch"]:not([data-slot="switch"]):focus-within, button[role="switch"]:not([data-slot="switch"]):active': {
				outline: 'none !important',
				boxShadow: 'none !important',
				border: 'none !important',
			},
			'[data-checked] button[role="switch"]:not([data-slot="switch"]):focus, [data-checked] button[role="switch"]:not([data-slot="switch"]):focus-visible, [data-checked] button[role="switch"]:not([data-slot="switch"]):active': {
				outline: 'none !important',
				boxShadow: 'none !important',
				border: 'none !important',
			},
			'button[role="switch"]:not([data-slot="switch"]) > *, button[role="switch"]:not([data-slot="switch"]) > *:focus, button[role="switch"]:not([data-slot="switch"]) > *:focus-visible': {
				outline: 'none !important',
				boxShadow: 'none !important',
			},
			'[data-checked] button[role="switch"]:not([data-slot="switch"]) > *, [data-checked] button[role="switch"]:not([data-slot="switch"]) > *:focus': {
				outline: 'none !important',
				boxShadow: 'none !important',
			},
			// More specific targeting for Chakra Switch classes
			'.chakra-switch:focus, .chakra-switch:focus-visible, .chakra-switch:focus-within, .chakra-switch:active': {
				outline: 'none !important',
				boxShadow: 'none !important',
			},
			'.chakra-switch__track:focus, .chakra-switch__track:focus-visible, .chakra-switch__track:active': {
				outline: 'none !important',
				boxShadow: 'none !important',
			},
			// Target any element with chakra-switch in class name
			'[class*="chakra-switch"]:focus, [class*="chakra-switch"]:focus-visible, [class*="chakra-switch"]:active': {
				outline: 'none !important',
				boxShadow: 'none !important',
			},
			// Force Urbanist font on Modal components
			'.chakra-modal__content, [data-chakra-modal]': {
				fontFamily: "'Urbanist', sans-serif !important"
			},
			'.chakra-modal__content *, [data-chakra-modal] *': {
				fontFamily: "'Urbanist', sans-serif !important"
			},
			// Trading Activity day modal: stat titles use Urbanist; body/table stay IBM Plex
			'.chakra-modal__content[data-trading-activity-day-modal="true"] [data-trade-log-mini-stat-title]': {
				fontFamily: "'Urbanist', sans-serif !important"
			},
			'.chakra-modal__content[data-trading-activity-day-modal="true"] [data-trade-log-mini-stat-body], .chakra-modal__content[data-trading-activity-day-modal="true"] [data-trade-log-mini-stat-body] *': {
				fontFamily: "'IBM Plex Sans', sans-serif !important"
			},
			'.chakra-modal__content[data-trading-activity-day-modal="true"] [data-trading-activity-day-modal-trades-table], .chakra-modal__content[data-trading-activity-day-modal="true"] [data-trading-activity-day-modal-trades-table] *': {
				fontFamily: "'IBM Plex Sans', sans-serif !important"
			},
			// Force IBM Plex Sans on FormLabels
			'label.chakra-form__label, .chakra-form__label': {
				fontFamily: "'IBM Plex Sans', sans-serif !important"
			},
		})
	}
};

